import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { routes } from "./Routes";
import AppLayout from "../components/layout";
import LoadingBar from "react-top-loading-bar";
import MenuMaster from "../components/MenuMaster/MenuMaster";

const LayoutRoutes = () => {
  const [progress, setProgress] = useState(0);
  return (
    <>
      <LoadingBar
        color="#f11946"
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Routes>
        {routes.map(({ path, Component }, i) => (
          <Route element={<AppLayout />} key={i}>
            <Route path={path} element={Component} />
          </Route>
        ))}
        <Route element={<AppLayout />}>
          <Route
            path={`${process.env.PUBLIC_URL}/:hwId/MenuMaster/:QpiId/:layout/*`}
            element={<MenuMaster />}
          />
          <Route
            path={`${process.env.PUBLIC_URL}/:hwId/MenuMaster/:QpiId/:productId/:layout/*`}
            element={<MenuMaster />}
          />
        </Route>
      </Routes>
    </>
  );
};

export default LayoutRoutes;
